var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"app-layout"},[_c('Sidebar',{staticStyle:{"flex-shrink":"0"}}),_c('el-container',{attrs:{"direction":"vertical"}},[_c('el-header',{staticStyle:{"padding":"0","flex-shrink":"0"}},[_c('Header')],1),_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }